/**
 * Created by Timur on 21.08.2026
 */

const Merge2MissionWindow = Prefab.createWindow((mission) => Merge2MissionHelper.getBundleName(mission.logic.period), "merge2mission_window_prefab_json", {
    bundles: ["merge2mission"]
});

Merge2MissionWindow.WINDOW_NAME = "merge2missionwindow";
